import HomeLayout from './HomeLayout';
import HubLayout from './HubLayout';
import TextLayout from './TextLayout';
import GalleryLayout from './GalleryLayout';
import InfoLayout from './InfoLayout';
import BlogLayout from './BlogLayout';
import StatsLayout from './StatsLayout';
import NewsLayout from './NewsLayout';
import ResourcesLayout from './ResourcesLayout';

export default {
    home: HomeLayout,
    hub: HubLayout,
    text: TextLayout,
    gallery: GalleryLayout,
    info: InfoLayout,
    blog: BlogLayout,
    stats: StatsLayout,
    news: NewsLayout,
    resources: ResourcesLayout,
};



// WEBPACK FOOTER //
// ./components/layouts/index.js